module.exports = __webpack_public_path__ + "img/24-small.fdc79c98.png";